import { ShippingMethodResponse } from '../api/responses';
import { ShippingMethod } from '../models/shipping-method';
import { valueOrDefault } from '@web/utils';
import { ShippingMethodProperty } from '../models/shipping-method-property';
import { ShippingMethodPropertyMetadata } from '../models/shipping-method-property-metadata';

export const shippingMethodFromResponse = (response: ShippingMethodResponse) =>
  new ShippingMethod({
    code: response.code,
    name: response.name,
    id: response.id,
    description: response.description,
    properties: response.properties.map(
      (property) =>
        new ShippingMethodProperty({
          code: property.code,
          name: property.name,
          value: property.value,
          metadata: valueOrDefault(property.metadata, []).map(
            (metadata) =>
              new ShippingMethodPropertyMetadata({
                code: metadata.code,
                value: metadata.value,
              }),
          ),
        }),
    ),
  });
